import React, { useEffect, useState } from "react";
import CourseHeader from "../header";
import '../Journal/journal.css'
import Footer from "../footer";
import StudentSideBar from "../student/sidebar";
import { useLocation, useParams } from "react-router-dom";
import Bannerpage from "../Banner";
import { useDispatch, useSelector } from "react-redux";
import { ContactInfoById } from "../../Redux/Contact/constactslice";
import axios from "axios";
import { settingsData } from "../../Redux/home/homeslice";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from 'react-toastify';
import ContentRenderer from "../ContentRender";
import addressImg from "../../assets/img/maps-and-flags.png"
import emailImg from "../../assets/img/email 1.png"
import reprintImg from "../../assets/img/reprint_1.png"
import phoneImg from "../../assets/img/phone-call.png"
// import mapImg from "../../assets/img/google-maps.png"

const JournalContact = () => {

  const { contactinfo } = useSelector((state) => state.contactData)

  console.log(contactinfo?.data, "contactinfo")

  const location = useLocation()

  console.log(location, "lcnt")

  // const [formData, setFormData] = useState({
  //   first_name: "",
  //   last_name: "",
  //   email: "",
  //   mobile: "",
  //   journalclassification_uuid: contactinfo?.data?.classification_uuid,
  //   message: ""
  // });

  // const handleSubmitAPI = (e) => {
  //   e.preventDefault()
  //   axios.post(`${process.env.REACT_APP_URL}/contactQuery`, formData)
  //     .then((res) => {
  //       console.log(res?.data)
  //       setFormData({
  //         first_name: "",
  //         last_name: "",
  //         email: "",
  //         mobile: "",
  //         journalclassification_uuid: "",
  //         message: ""
  //       })
  //     })
  //     .catch((err) => {
  //       console.log(err?.response?.data)
  //     })
  //   console.log(formData);
  // }

  // const handleChange = (event) => {
  //   const { name, value } = event.target;
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     [name]: value
  //   }));
  // };

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile: "",
    journalclassification_uuid: contactinfo?.data?.classification_uuid === undefined || null ? location?.state?.data : contactinfo?.data?.classification_uuid,
    message: ""
  });


  const handleSubmitAPI = (values, fun) => {
    // e.preventDefault()
    axios.post(`${process.env.REACT_APP_URL}/contactQuery`, values)
      .then((res) => {
        console.log(res?.data, "contactzz")
        setFormData({
          first_name: "",
          last_name: "",
          email: "",
          mobile: "",
          journalclassification_uuid: contactinfo?.data?.classification_uuid === undefined || null ? location?.state?.data : contactinfo?.data?.classification_uuid,
          message: ""
        })
        toast.success("Detailes Saved !")


        fun();

      })
      .catch((err) => {
        console.log(err?.response?.data)
        toast.error(err?.response?.data?.message ? err?.response?.data?.message : err?.response?.data)
      })
    console.log(formData);
  }


  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      mobile: "",
      journalclassification_uuid: contactinfo?.data?.classification_uuid === undefined || null ? location?.state?.data : contactinfo?.data?.classification_uuid,
      message: ""
    },
    validationSchema: Yup.object({
      first_name: Yup.string()
        .min(2, "First name must be at least 2 characters")
        .max(50, "First name cannot exceed 50 characters")
        .required("First name is required"),
      last_name: Yup.string()
        .min(2, "Last name must be at least 2 characters")
        .max(50, "Last name cannot exceed 50 characters")
        .required("Last name is required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      mobile: Yup.string()
        .matches(/^\d{10}$/, "Phone number must be 10 digits")
        .required("Phone number is required"),
      message: Yup.string()
        .min(10, "Message must be at least 10 characters")
        .required("Message is required"),
    }),
    onSubmit: (values, { resetForm }) => {
      const payload = {
        first_name: values?.first_name,
        last_name: values?.last_name,
        email: values?.email,
        mobile: values?.mobile,
        journalclassification_uuid: contactinfo?.data?.classification_uuid === undefined || null ? location?.state?.data : contactinfo?.data?.classification_uuid,
        message: values?.message
      }
      console.log("Form data", values);
      handleSubmitAPI(payload, resetForm);
      // Add your API call logic here
    },
  });


  const dispatch = useDispatch();
  const { slug } = useParams();

  useEffect(() => {
    dispatch(ContactInfoById(slug));
    dispatch(settingsData());
  }, [])

  const { settings } = useSelector((state) => state.Home);

  console.log(settings, "sdsds")


  const [mapUrl, setMapUrl] = useState("");


  useEffect(() => {
    if (contactinfo?.data?.map_iframe) {
      setMapUrl(contactinfo.data.map_iframe);
    }
  }, [contactinfo?.data]);


  // useEffect(() => {
  //   if (contactinfo?.data?.map_iframe) {
  //     // Parse HTML from map_iframe and extract the <oembed> URL
  //     const tempDiv = document.createElement("div");
  //     tempDiv.innerHTML = contactinfo?.data.map_iframe;
  //     const oembed = tempDiv.querySelector("oembed");

  //     if (oembed && oembed.getAttribute("url")) {
  //       setMapUrl(oembed.getAttribute("url"));
  //     }
  //   }
  // }, [contactinfo?.data]);
  // useEffect(() => {
  //   if (contactinfo?.data?.map_iframe) {
  //     const tempDiv = document.createElement("div");
  //     tempDiv.innerHTML = contactinfo?.data.map_iframe;
  //     const anchor = tempDiv.querySelector("a");
  //     const oembed = tempDiv.querySelector("oembed");

  //     if (oembed && oembed.getAttribute("url")) {
  //       let url = oembed.getAttribute("url");
  //       console.log("Found oembed URL:", url);
  //       if (url.includes("google.com/maps/embed")) {
  //         console.log("Using embed URL directly:", url);
  //         setMapUrl(url);
  //       } else {
  //         // Handle Google Maps directions URL
  //         const coordsMatch = url.match(/!2d(-?\d+\.\d+)!3d(-?\d+\.\d+)/);
  //         const placeMatch = url.match(/\/([^/]+)\/@/) || url.match(/\/([^/]+)$/);

  //         if (coordsMatch && placeMatch) {
  //           const latitude = coordsMatch[2];
  //           const longitude = coordsMatch[1];
  //           let placeName = decodeURIComponent(placeMatch[1]).replace(/\+/g, " ");
  //           placeName = placeName.split(/[@?]/)[0].trim();
  //           console.log("Extracted placeName:", placeName, "Coordinates:", { latitude, longitude });

  //           const embedUrl = `https://www.google.com/maps/embed/v1/place?q=${encodeURIComponent(placeName)}¢er=${latitude},${longitude}&zoom=15`;
  //           console.log("Constructed embedUrl:", embedUrl);
  //           setMapUrl(embedUrl);
  //         } else {
  //           console.log("Failed to extract coordinates or place name from oembed URL:", url);
  //           setMapUrl(null);
  //         }
  //       }
  //     } else if (anchor && anchor.getAttribute("href")) {
  //       let url = anchor.getAttribute("href");
  //       console.log("Found anchor URL:", url);
  //       if (url.includes("google.com/search")) {
  //         // Extract the query parameter from the search URL
  //         const queryMatch = url.match(/[?&]q=([^&]+)/);
  //         if (queryMatch) {
  //           const query = decodeURIComponent(queryMatch[1]).replace(/\+/g, " ").trim();
  //           console.log("Extracted search query:", query);
  //           const embedUrl = `https://www.google.com/maps/embed/v1/place?q=${encodeURIComponent(query)}&zoom=15`;
  //           console.log("Constructed embedUrl from search query:", embedUrl);
  //           setMapUrl(embedUrl);
  //         } else {
  //           console.log("No query parameter found in search URL:", url);
  //           setMapUrl(null);
  //         }
  //       } else {
  //         console.log("Anchor URL is not a Google Search URL:", url);
  //         setMapUrl(null);
  //       }
  //     } else {
  //       // Fallback to address field if no valid URL is found
  //       const placeName = contactinfo?.data?.address
  //         ? contactinfo.data.address.replace(/<[^>]+>/g, '').trim()
  //         : "";
  //       if (placeName) {
  //         const embedUrl = `https://www.google.com/maps/embed/v1/place?q=${encodeURIComponent(placeName)}&zoom=15`;
  //         console.log("Using address as fallback. PlaceName:", placeName, "EmbedUrl:", embedUrl);
  //         setMapUrl(embedUrl);
  //       } else {
  //         console.log("No address available for fallback.");
  //         setMapUrl(null);
  //       }
  //     }
  //   } else {
  //     console.log("No map_iframe data available.");
  //     setMapUrl(null);
  //   }
  // }, [contactinfo?.data]);

  return (
    <>
      <CourseHeader activeMenu={"CourseDetails"} />
      {/* <div className="breadcrumb-bar">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-12">
              <div className="breadcrumb-list">
                <nav aria-label="breadcrumb" className="page-breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item" aria-current="page">
                      Courses
                    </li>
                    <li className="breadcrumb-item" aria-current="page">
                      All Courses
                    </li>
                    <li className="breadcrumb-item" aria-current="page">
                      The Complete Web Developer Course 2.0
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <Bannerpage name={slug} />

      <div className="page-content">

        <div className="container-fluid">
          <h3>
            <center>
              Contact Us
            </center>
          </h3>
          <div className="row">
            <StudentSideBar />
            <div className="col-lg-8 col-md-8 col-sm-12 mx-auto">
              <div className="support-wrap">
                <div className="row">
                  <div className="col-md-5 col-lg-5 col-xl-5 col-sm-6">
                    {contactinfo?.data?.address && (
                      <span>
                        <div style={{ display: "flex" }}>
                          <img src={addressImg} alt="addressimg" style={{ width: "21px", height: "21px" }} />
                          <strong className="ms-1">Address</strong>
                        </div>
                        <br />
                        <label>
                          <ContentRenderer content={contactinfo?.data?.address} />
                        </label>
                      </span>
                    )}


                    {contactinfo?.data?.registered_address && (
                      <>
                        <br />
                        <span>
                          <div style={{ display: "flex" }}>
                            <img src={addressImg} alt="addressimg" style={{ width: "21px", height: "21px" }} />
                            <strong className="ms-1">Registered Address</strong>
                          </div>
                          <br />
                          <label
                          >
                            <ContentRenderer content={contactinfo?.data?.registered_address} />
                          </label>
                        </span>
                      </>
                    )}


                    {contactinfo?.data?.phone_number && (
                      <>
                      <br />
                        <span>
                          <div style={{ display: "flex" }}>
                            <img src={phoneImg} alt="addressimg" style={{ width: "21px", height: "21px" }} />
                            <strong className="ms-1">Phone Number</strong>
                          </div>
                          <br />
                          <label>
                            {contactinfo?.data?.phone_number}
                          </label>
                        </span>
                      </>
                    )}


                    {contactinfo?.data?.email && (
                      <>
                        <br />
                        <span>
                          <div style={{ display: "flex" }}>
                            <img src={emailImg} alt="addressimg" style={{ width: "21px", height: "21px" }} />
                            <strong className="ms-1">Email</strong>
                          </div>
                          <br />
                          <label>
                            {contactinfo?.data?.email}
                          </label>
                        </span>
                      </>
                    )}


                    {contactinfo?.data?.reprint_advertisement && (
                      <>
                      <br />
                        <span>
                          <div style={{ display: "flex" }}>
                            <img src={reprintImg} alt="addressimg" style={{ width: "21px", height: "21px" }} />
                            <strong className="ms-1">Reprints / Advertisement</strong>
                          </div>
                          <br />
                          <label>
                            {contactinfo?.data?.reprint_advertisement}
                          </label>
                        </span>
                      </>
                    )}
                    {/* {contactinfo?.data?.map_iframe && (
                      <span>
                        <strong>Map Iframe</strong>
                        <div>
                          {mapUrl && (
                            <a href={mapUrl} target="_blank" rel="noopener noreferrer">
                              <img
                                src={mapImg}
                                alt="Map Preview"
                                style={{
                                  width: "50%",
                                  maxWidth: "600px",
                                  height: "auto",
                                  borderRadius: "8px",
                                  cursor: "pointer",
                                  border: "1px solid #ccc",
                                }}
                              />
                            </a>
                          )}
                        </div>
                      </span>
                    )} */}

                    {/* copilot */}

                    {mapUrl && (
                      <>
                        <span>
                          <strong>Map Iframe</strong>

                          <div
                            style={{
                              width: "100%",
                              maxWidth: "600px",
                              height: "450px",
                              borderRadius: "8px",
                              overflow: "hidden",
                              border: "1px solid #ccc",
                              marginTop: "10px",
                            }}
                          >
                            <iframe
                              src={`https://www.google.com/maps?q=${encodeURIComponent(mapUrl)}&output=embed`}
                              width="100%"
                              height="100%"
                              style={{ border: 0 }}
                              allowFullScreen=""
                              loading="lazy"
                              referrerPolicy="no-referrer-when-downgrade"
                              title="Google Map"
                            ></iframe>
                          </div>

                        </span>
                      </>
                    )}

                  </div>

                  <div className={contactinfo?.data === null
                    ? "col-md-9 col-lg-9 col-xl-9 col-sm-9 mt-1"
                    : "col-md-6 col-lg-6 col-xl-6 col-sm-6"
                  }>
                    <h5> Journal Name :{slug}</h5>
                    {/* <form onSubmit={handleSubmitAPI} >
                      <div className="row">
                        <div className="col-12">
                          <div className="form-group">
                            <label>First Name</label>
                            <input
                              name="first_name"
                              value={formData.first_name}
                              onChange={handleChange}
                              type="text"
                              className="form-control"
                              placeholder="Enter your first name"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-12">
                          <div className="form-group">
                            <label>Last Name</label>
                            <input
                              name="last_name"
                              value={formData.last_name}
                              onChange={handleChange}
                              type="text"
                              className="form-control"
                              placeholder="Enter your last name"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-12">
                          <div className="form-group">
                            <label>Email</label>
                            <input
                              name="email"
                              value={formData.email}
                              onChange={handleChange}
                              type="email"
                              className="form-control"
                              placeholder="Enter your email address"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-12">
                          <div className="form-group">
                            <label>Phone</label>
                            <input
                              name="mobile"
                              value={formData.mobile}
                              onChange={handleChange}
                              type="tel"
                              className="form-control"
                              placeholder="Enter your phone number"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-12">
                          <div className="form-group">
                            <label>Message</label>
                            <textarea
                              name="message"
                              value={formData.message}
                              onChange={handleChange}
                              className="form-control"
                              placeholder="Write down here"
                              rows={4}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-12">
                          <button className="btn-submit">Submit</button>
                        </div>
                      </div>
                    </form> */}
                    <form onSubmit={formik.handleSubmit}>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-group">
                            <label>First Name</label>
                            <input
                              name="first_name"
                              type="text"
                              className={formik.touched.first_name && formik.errors.first_name ? "form-control is-invalid" : "form-control"}
                              placeholder="Enter your first name"
                              value={formik.values.first_name}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                            {/* {formik.touched.first_name && formik.errors.first_name ? (
              <div className="error">{formik.errors.first_name}</div>
            ) : null} */}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-12">
                          <div className="form-group">
                            <label>Last Name</label>
                            <input
                              name="last_name"
                              type="text"
                              className={formik.touched.last_name && formik.errors.last_name ? "form-control is-invalid" : "form-control"}
                              placeholder="Enter your last name"
                              value={formik.values.last_name}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                            {/* {formik.touched.last_name && formik.errors.last_name ? (
              <div className="error">{formik.errors.last_name}</div>
            ) : null} */}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-12">
                          <div className="form-group">
                            <label>Email</label>
                            <input
                              name="email"
                              type="email"
                              className={formik.touched.email && formik.errors.email ? "form-control is-invalid" : "form-control"}
                              placeholder="Enter your email address"
                              value={formik.values.email}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                            {/* {formik.touched.email && formik.errors.email ? (
              <div className="error">{formik.errors.email}</div>
            ) : null} */}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-12">
                          <div className="form-group">
                            <label>Phone</label>
                            <input
                              name="mobile"
                              type="tel"
                              className={formik.touched.mobile && formik.errors.mobile ? "form-control is-invalid" : "form-control"}
                              placeholder="Enter your phone number"
                              value={formik.values.mobile}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                            {formik.touched.mobile && formik.errors.mobile ? (
                              <div className="error">{formik.errors.mobile}</div>
                            ) : null}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-12">
                          <div className="form-group">
                            <label>Message</label>
                            <textarea
                              name="message"
                              className={formik.touched.message && formik.errors.message ? "form-control is-invalid" : "form-control"}
                              placeholder="Write down here"
                              rows={4}
                              value={formik.values.message}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                            {/* {formik.touched.message && formik.errors.message ? (
              <div className="error">{formik.errors.message}</div>
            ) : null} */}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-12">
                          <button type="submit" className="btn btn-primary">
                            Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default JournalContact